import { useEffect } from 'react'; // ADD THIS IMPORT
import { useDispatch, useSelector } from 'react-redux';
import { toggleMenu, closeMenu } from '../store/frontPageSlice';

/**
 * Custom hook for menu functionality
 * @returns {Object} Menu controls and state
 */
export const useMenu = () => {
  const dispatch = useDispatch();
  const isMenuOpen = useSelector((state) => state.frontPage.isMenuOpen);

  const handleToggleMenu = () => {
    dispatch(toggleMenu());
  };

  const handleCloseMenu = () => {
    dispatch(closeMenu());
  };

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isMenuOpen) {
        handleCloseMenu();
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen, handleCloseMenu]); // Added handleCloseMenu dependency

  return {
    isMenuOpen,
    toggleMenu: handleToggleMenu,
    closeMenu: handleCloseMenu,
  };
};